import { useState, useEffect } from 'react'
import { get } from 'aws-amplify/api'

import { demandResponseDevice } from 'types/Device'
import { getCachedAuthSession } from 'services/authSessionCache'

const useServerlessDemandResponse = (deviceId: string, autoRefresh: boolean) => {
  const [demandResponse, setDemandResponse] = useState<demandResponseDevice | null>(null)
  const [isDemandResponseLoaded, setIsDemandResponseLoaded] = useState(false)

  useEffect(() => {
    setIsDemandResponseLoaded(false)

    const fetchDemandResponse = async () => {
      const session = await getCachedAuthSession()

      try {
        const res = await get({
          apiName: 'dwaApi',
          path: `/demand-response?deviceId=${deviceId}`,
          options: {
            headers: { 'Authorization': session?.tokens?.idToken?.toString() || '' }
          }
        }).response

        const DemandResponse = await res.body.json()
        setDemandResponse(DemandResponse as unknown as demandResponseDevice)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (_error) {
        setDemandResponse(null)
      } finally {
        setIsDemandResponseLoaded(true)
      }
    }

    fetchDemandResponse()

    if (autoRefresh) {
      const pollingInterval = setInterval(fetchDemandResponse, 5000) // poll every 5 seconds
      return () => clearInterval(pollingInterval)
    }
  }, [deviceId, autoRefresh])

  return {
    demandResponse,
    isDemandResponseLoaded
  }
}

export default useServerlessDemandResponse
